import {BufferGeometry} from 'three'
import {RenderableObjectParser} from './base'

// A loader that should only be used to load
// non-existant geometry. Will produce a legitmate
// scene graph object, but it will not result in any
// pixels lighting up.
//
// Primarily used for 3D diffs, where a null component
// is easier to manage than a series of special cases.

// Deprecated
export class NullParser extends RenderableObjectParser {
  parse() {
    const geometry = new BufferGeometry()
    geometry.computeBoundingBox()
    geometry.computeBoundingSphere()

    this.announce(geometry)
  }
}
